import { CostReviewProvenOutcomesProactiveServicesSa } from "./CostReviewProvenOutcomesProactiveServicesSa";
import { CostReviewSiteQualificationSa } from "./CostReviewSiteQualificationSa";
import { CostReviewSummarySa } from "./CostReviewSummarySa";
import { CostReviewEnUsRisksSa } from "./CostReviewEnUsRisksSa";
import { CostReviewServicesSa } from "./CostReviewServicesSa";
import { CostReviewMarginSa } from "./CostReviewMarginSa";
import { CostReviewEnUsToolsSa } from "./CostReviewEnUsToolsSa";
import { CostReviewEquipmentSa } from "./CostReviewEquipmentSa";
import { CostReviewAgreementScopeSa } from "./CostReviewAgreementScopeSa";
import { CostReviewSAPContractTypeSa } from "./CostReviewSAPContractTypeSa";
import { CostReviewCostAndLaborDetailsSa } from "./CostReviewCostAndLaborDetailsSa";

export class CostReviewServiceAgreementAttributes {

    costReviewSummarySa: CostReviewSummarySa = new CostReviewSummarySa();

    costReviewMarginSa: CostReviewMarginSa[] = new Array<CostReviewMarginSa>();

    costReviewCostAndLaborDetailsSa: CostReviewCostAndLaborDetailsSa[] = new Array<CostReviewCostAndLaborDetailsSa>();

    costReviewSiteQualificationSa: CostReviewSiteQualificationSa = new CostReviewSiteQualificationSa();

    costReviewProvenOutcomesProactiveServicesSa: CostReviewProvenOutcomesProactiveServicesSa = new CostReviewProvenOutcomesProactiveServicesSa();

    costReviewAgreementScopeSa: CostReviewAgreementScopeSa = new CostReviewAgreementScopeSa();

    costReviewEquipmentSa: CostReviewEquipmentSa = new CostReviewEquipmentSa();

    costReviewRisksSa: CostReviewEnUsRisksSa = new CostReviewEnUsRisksSa();

    costReviewToolsSa: CostReviewEnUsToolsSa = new CostReviewEnUsToolsSa();

    costReviewServicesSa: CostReviewServicesSa[] = new Array<CostReviewServicesSa>();

    costReviewSAPContractTypeSa:CostReviewSAPContractTypeSa[] = new Array<CostReviewSAPContractTypeSa>();
}